module.exports = __webpack_public_path__ + "660c72dd639da76082820938518d08d9.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/teaser-1080.mp4
// module id = 651
// module chunks = 0